import { render } from "./workflowstatistic-item.vue?vue&type=template&id=6d957e55"
import script from "./workflowstatistic-item.vue?vue&type=script&lang=js"
export * from "./workflowstatistic-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__